module.exports = __webpack_public_path__ + "staticVue/media/video2.a9a03e36.mp4";